export type LoadingStage = "hidden" | "waiting" | "slow";
export type SceneResult<T> = { status: "ready"; value: T } | { status: "error" };

/** A soft deadline: offer control, never silently turn normal motion off. */
export function watchLoading(update: (stage: LoadingStage) => void) {
  const hint = setTimeout(() => update("waiting"), 800);
  const escape = setTimeout(() => update("slow"), 6000);
  return () => { clearTimeout(hint); clearTimeout(escape); };
}

/** Imports cannot be aborted, but an abandoned request must not reclaim the UI. */
export function beginSceneLoad<T>(load: () => Promise<T>, update: (result: SceneResult<T>) => void) {
  let current = true;
  void Promise.resolve().then(load).then(
    value => { if (current) update({ status: "ready", value }); },
    () => { if (current) update({ status: "error" }); },
  );
  return () => { current = false; };
}
